// src/data/constants.ts
// This file contains shared constants to avoid circular dependencies.

export const DOMAIN_KNOWLEDGE_MAPPING = {
  // 六项内在能力基础评估
  cognition: {
    pass: ["ICOPE-C3-S3.1.3-Advice-BrainHealth"],
    fail: ["ICOPE-C3-S3.1.5-Community-Care-Overview", "ICOPE-C5-S5.2-Community-Care-Overview"]
  },
  mobility: {
    pass: ["ICOPE-C3-S3.1.3-Advice-PhysicalActivity"],
    fail: ["ICOPE-C3-S3.1.5-Community-Care-Overview", "ICOPE-C6-S6.2-CommunityExerciseIntervention"]
  },
  vitality: {
    pass: ["ICOPE-C3-S3.1.3-Advice-HealthyDiet"],
    fail: ["ICOPE-C3-S3.1.5-Community-Care-Overview", "ICOPE-C7-S7.2-CommunityIntervention"]
  },
  vision: {
    pass: ["ICOPE-C3-S3.1.3-Advice-EyeHealth"],
    fail: ["ICOPE-C3-S3.1.5-Community-Care-Overview", "ICOPE-C8-S8.2-Community-Care-Vision"]
  },
  hearing: {
    pass: ["ICOPE-C3-S3.1.3-Advice-EarHealth"],
    fail: ["ICOPE-C3-S3.1.5-Community-Care-Overview", "ICOPE-C9-S9.2-Community-Care-Hearing"]
  },
  psychologicalCapacity: {
    pass: ["ICOPE-C3-S3.1.3-Advice-MentalHealth"],
    fail: ["ICOPE-C3-S3.1.5-Community-Care-Overview", "ICOPE-C10-S10.2-Community-Care-Depression"]
  },
  // 关键健康影响因素评估
  socialCareSupport: {
    ok: ["ICOPE-C3-S3.1.3-Advice-SocialConnection"],
    needsAttention: ["ICOPE-C11-S11.1-SocialCare-Overview"]
  },
  carerSupport: {
    supported: [],
    needsAttention: ["ICOPE-C12-S12.1-CarerSupport-Overview"]
  },
  urinaryIncontinence: {
    ok: [],
    needsAttention: ["ICOPE-C13-S13.1-UrinaryIncontinence-Overview"]
  }
};
